import { CanvasRenderingTarget2D } from 'fancy-canvas'
import { ISeriesPrimitivePaneRenderer } from 'lightweight-charts'
import DrawingBase from './drawing.base'


export type DrawingPaneRendererOptions = {
    id: string,
    drawing: DrawingBase<any, any, any>
}

class DrawingPaneRenderer implements ISeriesPrimitivePaneRenderer {
    drawing: DrawingBase<any, any, any>
    id: string

    constructor(options: DrawingPaneRendererOptions) {
        this.drawing = options.drawing
        this.id = options.id
    }

    draw(target: CanvasRenderingTarget2D) {
        target.useBitmapCoordinateSpace(scope => {
            const { horizontalPixelRatio, verticalPixelRatio, mediaSize: { width, height } } = scope
            this.drawing.horizontalPixelRatio = horizontalPixelRatio
            this.drawing.verticalPixelRatio = verticalPixelRatio
            this.drawing.canvasWidth = width * horizontalPixelRatio
            this.drawing.canvasHeight = height * verticalPixelRatio
            this.drawing.draw(scope, target)

            if (this.id === 'primary' && 
                this.drawing.mode === 'DRAW' && 
                this.drawing._firstClick && 
                this.drawing.previewCursorPosition) {
                this.drawing.drawPreviewCursorDot(scope)
            }
        })
    }
}


export default DrawingPaneRenderer